import { render, staticRenderFns } from "./SummaryTabButtons.vue?vue&type=template&id=33f74979&scoped=true&"
import script from "./SummaryTabButtons.vue?vue&type=script&lang=js&"
export * from "./SummaryTabButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f74979",
  null
  
)

export default component.exports